import { toggleMark } from '../../../../node_modules/prosemirror-commands/dist/index.es.js';
import { Mark } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { strike } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/strike.js';
import { markInputRule, markPasteRule } from '../../../../node_modules/tiptap-commands/dist/commands.esm.js';

/* eslint-disable */
class Strike extends Mark {
  get name() {
    return 'strike';
  }

  get schema() {
    return strike;
  }

  keys({
    type
  }) {
    return {
      'Mod-d': toggleMark(type)
    };
  }

  commands({
    type
  }) {
    return () => toggleMark(type);
  }

  inputRules({
    type
  }) {
    return [markInputRule(/~([^~]+)~$/, type)];
  }

  pasteRules({
    type
  }) {
    return [markPasteRule(/~([^~]+)~/g, type)];
  }

}

export default Strike;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/marks/Strike.js